import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-bar" }
const _hoisted_3 = { class: "page-bar-main" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "page-filters pf-bar" }
const _hoisted_6 = { class: "pf-search" }
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "full-table" }
const _hoisted_12 = { class: "table-labels" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  style: {"margin-top":"3px"}
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "row-menu" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "row-menu-dropdown"
}
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_tip = _resolveComponent("info-tip")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!
  const _component_add_edit_employee = _resolveComponent("add-edit-employee")!
  const _component_add_employee_review = _resolveComponent("add-employee-review")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "page-bar-sub" }, "Team", -1)),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.$store.state.user.teamHubRole != 'Admin')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "My "))
            : _createCommentVNode("", true),
          _cache[14] || (_cache[14] = _createTextVNode("Employees", -1)),
          (_ctx.$store.state.user.isAdmin)
            ? (_openBlock(), _createBlock(_component_info_tip, {
                key: 1,
                text: "Employee records are Team Hub records and don't always represent users who can sign in to the Ironbook. To add a new user to the Ironbook, add them in Settings > Standard Users first."
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[16] || (_cache[16] = _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            "aria-hidden": "true"
          }, [
            _createElementVNode("circle", {
              cx: "11",
              cy: "11",
              r: "7"
            }),
            _createElementVNode("path", { d: "M21 21l-4.35-4.35" })
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQ) = $event)),
            placeholder: "Search",
            "aria-label": "Search",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search()))
          }, null, 544), [
            [_vModelText, _ctx.searchQ]
          ])
        ]),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.status) = $event)),
          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.search()))
        }, [...(_cache[17] || (_cache[17] = [
          _createElementVNode("option", { value: "Active" }, "Active", -1),
          _createElementVNode("option", { value: "Terminated" }, "Terminated", -1)
        ]))], 544), [
          [_vModelSelect, _ctx.status]
        ]),
        (_ctx.$store.state.user.isAdmin)
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedLocation) = $event)),
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.search()))
            }, [
              _cache[18] || (_cache[18] = _createElementVNode("option", { value: "ALL" }, "All Locations", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.locations, (loc, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: i,
                  value: loc
                }, _toDisplayString(loc), 9, _hoisted_7))
              }), 128))
            ], 544)), [
              [_vModelSelect, _ctx.selectedLocation]
            ])
          : _createCommentVNode("", true),
        (_ctx.$store.state.user.companyID == 1)
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 1,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedShift) = $event)),
              onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.search()))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shiftOptions, (o, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: o.value,
                  key: i
                }, _toDisplayString(o.label), 9, _hoisted_8))
              }), 128))
            ], 544)), [
              [_vModelSelect, _ctx.selectedShift]
            ])
          : _createCommentVNode("", true),
        (_ctx.$store.state.user.teamHubRole == 'Admin')
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 2,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedManager) = $event)),
              onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.search()))
            }, [
              _cache[19] || (_cache[19] = _createElementVNode("option", { value: null }, "Reporting To", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.managerEmployees, (o, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: o.ID,
                  key: i
                }, _toDisplayString(o.Name), 9, _hoisted_9))
              }), 128))
            ], 544)), [
              [_vModelSelect, _ctx.selectedManager]
            ])
          : _createCommentVNode("", true),
        _cache[20] || (_cache[20] = _createElementVNode("span", { class: "pf-spacer" }, null, -1)),
        _createElementVNode("div", {
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addNewEmployee())),
          class: "add-btn"
        }, "Add"),
        _createElementVNode("a", {
          class: "add-btn",
          href: `${_ctx.$store.state.apiUrl}/api/employees/employees.csv`,
          download: ""
        }, "Export", 8, _hoisted_10)
      ]),
      _createElementVNode("table", _hoisted_11, [
        _createElementVNode("tbody", null, [
          _createElementVNode("tr", _hoisted_12, [
            _cache[21] || (_cache[21] = _createElementVNode("td", null, "Name", -1)),
            _cache[22] || (_cache[22] = _createElementVNode("td", null, "Title", -1)),
            (_ctx.$store.state.user.companyID == 1)
              ? (_openBlock(), _createElementBlock("td", _hoisted_13, "Role"))
              : _createCommentVNode("", true),
            (_ctx.$store.state.user.companyID == 1)
              ? (_openBlock(), _createElementBlock("td", _hoisted_14, "Shift"))
              : _createCommentVNode("", true),
            _cache[23] || (_cache[23] = _createElementVNode("td", null, "Email", -1)),
            _cache[24] || (_cache[24] = _createElementVNode("td", null, "Phone", -1)),
            _cache[25] || (_cache[25] = _createElementVNode("td", null, null, -1))
          ]),
          _cache[26] || (_cache[26] = _createElementVNode("tr", { style: {"padding":"0","height":"0"} }, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.employees, (e, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (_ctx.viewEmployee(e))
                }, _toDisplayString(e.Name), 9, _hoisted_15),
                (e.NeedsReview && _ctx.status == 'Active')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, "*needs review"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, _toDisplayString(e.SeatTitle), 1),
              (_ctx.$store.state.user.companyID == 1)
                ? (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString(e.Role), 1))
                : _createCommentVNode("", true),
              (_ctx.$store.state.user.companyID == 1)
                ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(e.Shift), 1))
                : _createCommentVNode("", true),
              _createElementVNode("td", null, [
                (e.Email)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: 'mailto:'+e.Email,
                      target: "_blank"
                    }, _toDisplayString(e.Email), 9, _hoisted_19))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, [
                (e.Phone)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: 'tel:'+e.Phone,
                      target: "_blank"
                    }, _toDisplayString(_ctx.formatPhone(e.Phone)), 9, _hoisted_20))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "row-menu-btn",
                    onClick: _withModifiers(($event: any) => (_ctx.toggleRowMenu(e)), ["stop"])
                  }, [
                    _createVNode(_component_svg_icon, { icon: "dots" })
                  ], 8, _hoisted_22),
                  (_ctx.openMenuID == e.ID)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("a", {
                          onClick: ($event: any) => {_ctx.openMenuID = null; _ctx.editEmployee(e)}
                        }, "Edit", 8, _hoisted_24),
                        _createElementVNode("a", {
                          onClick: ($event: any) => {_ctx.openMenuID = null; _ctx.reviewEmployee(e)}
                        }, "Review", 8, _hoisted_25),
                        _createElementVNode("a", {
                          onClick: ($event: any) => {_ctx.openMenuID = null; _ctx.deleteEmployee(e)}
                        }, "Delete", 8, _hoisted_26)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128))
        ])
      ])
    ], 2),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 0,
          onConfirm: _ctx.deleteConfirm,
          onCancel: _cache[11] || (_cache[11] = () => { _ctx.showConfirmDelete = false; }),
          msg: "Are you sure you would like to delete this employee?"
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.showAddEdit)
      ? (_openBlock(), _createBlock(_component_add_edit_employee, {
          key: 1,
          employeeToEdit: _ctx.employeeToEdit,
          onClose: _cache[12] || (_cache[12] = () => { _ctx.showAddEdit = false; _ctx.getEmployees(); })
        }, null, 8, ["employeeToEdit"]))
      : _createCommentVNode("", true),
    (_ctx.showReview)
      ? (_openBlock(), _createBlock(_component_add_employee_review, {
          key: 2,
          employee: _ctx.employeeToReview,
          employeeReviewFields: _ctx.employeeReviewFields,
          onClose: _cache[13] || (_cache[13] = () => { _ctx.showReview = false; _ctx.getEmployees() })
        }, null, 8, ["employee", "employeeReviewFields"]))
      : _createCommentVNode("", true)
  ]))
}